export default "__VITE_ASSET__cde65468__"